<template>
<div>
  <vs-popup class="gopos-ordr-detail" title="Order Detail" :active.sync="popupOrderDetail.isOpen" fullscreen>
    <div id="go-pos-order-detail">
        <div class="go-pos-order-detail">
            <vx-card class="left-content">
                <h4 class="font-bold text-2xl mb-6">Order OD{{this.orderDetail.id}}</h4>
                <div class="flex justify-between mb-5">
                    <div class="payment-card">
                        <p class="title font-bold">Credit Card</p>
                        <p class="text-xl text-primary-light font-bold" v-if="this.credit_card != null">${{this.credit_card}}</p>
                        <p class="text-xl text-primary-light font-bold" v-else>$0</p>
                    </div>
                    <div class="payment-card">
                        <p class="title font-bold">Cash</p>
                        <p class="text-xl text-primary-light font-bold" v-if="this.cash != null">${{this.cash}}</p>
                        <p class="text-xl text-primary-light font-bold" v-else>$0</p>
                    </div>
                    <div class="payment-card">
                        <p class="title font-bold">Gift Card</p>
                        <p class="text-xl text-primary-light font-bold" v-if="this.gift_card != null">${{this.gift_card}}</p>
                        <p class="text-xl text-primary-light font-bold" v-else>$0</p>
                    </div>
                    <div class="payment-card">
                        <p class="title font-bold">Check</p>
                        <p class="text-xl text-primary-light font-bold" v-if="this.check != null">${{this.check}}</p>
                        <p class="text-xl text-primary-light font-bold" v-else>$0</p>
                    </div>
                    <div class="payment-card" v-if="this.ach">
                        <p class="title font-bold">ACH</p>
                        <p class="text-xl text-primary-light font-bold" v-if="this.ach != null">${{this.ach}}</p>
                        <p class="text-xl text-primary-light font-bold" v-else>$0</p>
                    </div>
                    <div class="payment-card">
                        <p class="title font-bold">External Credit</p>
                        <p class="text-xl text-primary-light font-bold" v-if="this.external_credit_card != null">${{this.external_credit_card}}</p>
                        <p class="text-xl text-primary-light font-bold" v-else>$0</p>
                    </div>
                </div>

                <div class="history-list">
                    <!-- <div class="h-full overflow-y-auto py-2" v-if="this.historyOrderList && this.historyOrderList.items">
                        <div class='history-item-card' v-for="(item, index) in this.historyOrderList.items" :key="index">
                            <div class="con-tab-ejemplo py-2 px-3 leading-tight">
                                <p class="font-bold mt-4 mb-6 text-primary" v-if="checkinShowYear[index]">{{getYear(item.created_date)}}</p>
                                <div class="flex align-center pt-1 history-card cursor-pointer" @click="goToOrder(item)">
                                    <div class="pr-6">
                                        <p class="font-bold text-2xl pt-0">{{getDayOfMonth(item.created_date)}}</p>
                                        <p class="text-grey-custom pt-0">{{getMonth(item.created_date)}}</p>
                                    </div>
                                    <div>
                                        <p class="pt-0"><span class="text-grey-custom text-xs">{{getDayOfWeek(item.created_date) + ' '}}{{item.created_time}}</span></p>
                                        <p class="font-bold text-md pt-0">OD{{item.id}}</p>
                                    </div>
                                    <div class="font-bold ml-auto text-base">${{parseFloat(item.total_after_discount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="h-full overflow-y-auto py-2 px-4 text-black transaction-content" v-if="orderDetail.payment_history && orderDetail.payment_history.length > 0">
                      <div class="flex mb-6" v-if="paymentHistory.payment">
                        <div class="w-1/4 font-bold">Payment</div>
                        <div class="w-1/2">
                          <p class="font-bold mb-6">{{ paymentHistory.payment.created_date }}<span class="d-inline-block ml-4">{{ paymentHistory.payment.created_time }}</span></p>
                          <div class="flex align-center mb-3">
                            <!-- <img src="../../assets/images/primary-check-icon.png" class="mr-2" /> -->
                            <feather-icon icon="CheckIcon" svgClasses="w-6 h-6 stroke-current text-primary mr-2" />
                            <p class="mb-0">Payment successful</p>
                          </div>
                          <div class="flex" v-if="!paymentHistory.is_pax">
                            <span class="d-inline-block w-1/2 text-grey-custom">Tender:</span>
                            <span>{{ paymentHistory.payment.tender }}</span>
                          </div>
                          <div v-if="paymentHistory.is_pax">
                            <div class="flex">
                              <span class="d-inline-block w-1/2 text-grey-custom">Card Details: </span>
                              <span>{{ paymentHistory.payment.cardType }} {{ paymentHistory.payment.last4 }}</span>
                            </div>
                            <div class="flex">
                              <span class="d-inline-block w-1/2 text-grey-custom">Transaction #: </span>
                              <span>{{ paymentHistory.payment.transactionNo }}</span>
                            </div>
                          </div>
                          <div v-else>
                            <div class="flex">
                              <span class="d-inline-block w-1/2 text-grey-custom">Payment ID: </span>
                              <span>{{ paymentHistory.payment.paymentId }}</span>
                            </div>
                            <div class="flex">
                              <span class="d-inline-block w-1/2 text-grey-custom">Order ID: </span>
                              <span>{{ paymentHistory.payment.orderId }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="w-1/4 font-bold text-right">${{ paymentHistory.payment.amount }}</div>
                      </div>

                      <div class="solid-line" v-if="paymentHistory.tip"></div>

                      <div class="flex font-bold py-4" v-if="paymentHistory.tip">
                        <div class="w-1/2">Tip</div>
                        <div class="w-1/2 text-right">${{ paymentHistory.tip }}</div>
                      </div>

                      <div class="solid-line" v-if="paymentHistory.void || paymentHistory.refund"></div>

                      <div class="flex py-4" v-if="paymentHistory.refund">
                        <div class="w-1/4 font-bold">Refund</div>
                        <div class="w-1/2">
                          <p class="font-bold mb-6">{{ paymentHistory.refund.created_date }}<span class="d-inline-block ml-4">{{ paymentHistory.refund.created_time }}</span></p>
                          <div class="flex align-center mb-3">
                            <!-- <img src="../../assets/images/primary-check-icon.png" class="mr-2" /> -->
                            <feather-icon icon="CheckIcon" svgClasses="w-6 h-6 stroke-current text-primary mr-2" />
                            <p class="mb-0">Refund successful</p>
                          </div>
                          <div v-if="paymentHistory.is_pax">
                            <div class="flex">
                              <span class="d-inline-block w-1/2 text-grey-custom">Transaction #: </span>
                              <span>{{ paymentHistory.refund.transactionNo }}</span>
                            </div>
                          </div>
                          <div v-else>
                            <div class="flex">
                              <span class="d-inline-block w-1/2 text-grey-custom">Payment ID: </span>
                              <span>{{ paymentHistory.refund.paymentId }}</span>
                            </div>
                            <div class="flex">
                              <span class="d-inline-block w-1/2 text-grey-custom">Order ID: </span>
                              <span>{{ paymentHistory.refund.orderId }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="w-1/4 font-bold text-danger text-right">-${{ paymentHistory.refund.amount }}</div>
                      </div>

                      <div class="flex py-4" v-if="paymentHistory.void">
                        <div class="w-1/4 font-bold">Void</div>
                        <div class="w-1/2">
                          <p class="font-bold mb-6">{{ paymentHistory.void.created_date }}<span class="d-inline-block ml-4">{{ paymentHistory.void.created_time }}</span></p>
                          <div class="flex align-center mb-3">
                            <!-- <img src="../../assets/images/primary-check-icon.png" class="mr-2" /> -->
                            <feather-icon icon="CheckIcon" svgClasses="w-6 h-6 stroke-current text-primary mr-2" />
                            <p class="mb-0">Void successful</p>
                          </div>
                          <!-- <div class="flex">
                            <span class="d-inline-block w-1/2 text-grey-custom">Tender: </span>
                            <span>to {{ paymentHistory.void.tender }}</span>
                          </div> -->
                          <div v-if="paymentHistory.is_pax">
                            <div class="flex">
                              <span class="d-inline-block w-1/2 text-grey-custom">Transaction #: </span>
                              <span>{{ paymentHistory.void.transactionNo }}</span>
                            </div>
                          </div>
                          <div v-else>
                            <div class="flex">
                              <span class="d-inline-block w-1/2 text-grey-custom">Payment ID: </span>
                              <span>{{ paymentHistory.void.paymentId }}</span>
                            </div>
                            <div class="flex">
                              <span class="d-inline-block w-1/2 text-grey-custom">Order ID: </span>
                              <span>{{ paymentHistory.void.orderId }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="w-1/4 font-bold text-danger text-right">-${{ paymentHistory.void.amount }}</div>
                      </div>
                    </div>

                    <div class="flex justify-center w-full mt-12 bt-12" v-else>
                      No data available
                    </div>
                </div>

                <!-- <div class="group-btn flex mt-4">
                    <div class="w-1/2 pr-3">
                        <vs-button type="border" class="w-full" @click="closePopup">Close</vs-button>
                    </div>
                    <div class="w-1/2 pl-2">
                        <vs-button class="w-full gradient gradient-danger no-shadow">Delete</vs-button>
                    </div>
                </div> -->
            </vx-card>

            <vx-card class="right-content" v-if="this.orderDetail" :key="right_content_key">
                <div class="mb-3">
                    <div class="flex mx-2">
                        <div class="customer-name-group">
                            <div class="tooltip">
                                <vs-button class="mr-3 customer-name" @click.stop>
                                  {{this.orderDetail.customer_name}}
                                </vs-button>
                                <span class="tooltiptext" style="word-wrap: break-word; word-break: break-word;">{{this.orderDetail.customer_name}}</span>
                            </div>
                            <div class="flex text-grey-custom text-sm mt-1" v-if="this.orderDetail.customer_phone != null">
                                <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4 font-bold mr-1" />
                                {{StringHelper.phoneNumberFormat(this.orderDetail.customer_phone)}}
                            </div>
                            <div class="flex text-grey-custom text-sm mt-1" v-else>
                                <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4 font-bold mr-1" />
                                Unknown
                            </div>
                        </div>
                        <vs-alert :color="getStatusColor(this.orderDetail.pos_status)" class=" ml-2 flex-center customer-type" style="width: 150px; height: 40px !important">
                          {{getNameStatus(this.orderDetail.pos_status)}}
                        </vs-alert>
                    </div>
                </div>
                <div class="mb-3">
                    <div class="vx-row mx-2 point-visit-time">
                        <div class="vx-col w-6/24 mb-2 p-0">
                            <div class="text-sm text-grey-custom">Points</div>
                            <p class="text-sm p-0 pt-1">{{this.orderDetail.current_point}} Pts</p>
                        </div>
                        <div class="vx-col w-6/24 mb-2 p-0">
                            <div class="text-sm text-grey-custom">Visit</div>
                            <p class="text-sm p-0 pt-1" v-if="this.orderDetail.visit_count > 1">{{this.orderDetail.visit_count}} times</p>
                            <p class="text-sm p-0 pt-1" v-else>{{this.orderDetail.visit_count}} time</p>
                        </div>
                        <div class="vx-col w-12/24 mb-2 p-0">
                            <div class="text-sm text-grey-custom">Check in</div>
                            <p class="text-sm p-0 pt-1">{{changeFormat(this.orderDetail.created_at)}}</p>
                        </div>
                    </div>
                    <!-- <div class="flex mx-2 align-center cursor-pointer" @click="popupNote = true">
                        <div class="flex align-center text-sm break-word p-0 text-grey-custom" style="height: 35px">
                            <span class="font-semibold">Note:</span>
                            <div class="text-grey-custom ml-2 break-word order-detail-note note-content">{{note_view}}</div>
                        </div>
                        <div class="ml-auto">
                            <i class="material-icons ml-auto cursor-pointer gradient gradient-primary no-shadow text-white user-select-none order-detail-edit-icon">create</i>
                        </div>
                    </div>

                    <vs-popup class="checkout-popup-note" title="Note" :active.sync="popupNote">
                        <div class="pt-4">
                            <vs-textarea v-model="note" height="200"/>
                            <btn-custom @click="updateNote">Save</btn-custom>
                        </div>
                    </vs-popup> -->
                </div>


                <div class="selected-list text-custom-font" :class="{ 'has-refunded': this.orderDetail.pos_status == 'refunded',
                                                                      'has-amount-info': this.orderDetail.amount_info && this.orderDetail.amount_info.amount_due > 0,
                                                                      'has-service-fee': this.orderDetail.service_fee }">
                    <div class="h-full overflow-y-auto px-3" v-if="this.orderDetail && this.orderDetail.order_items">
                        <div class="selected-item-card" v-for="(item, index) in this.orderDetail.order_items" :key="index">
                            <div class="border-left" :style="`background: ${item.color}`"></div>
                            <div class="border-bottom-custom pb-2">
                                <div class="flex align-center text-xl font-bold color-black">
                                    <span v-if="item.staff_name != null">{{item.staff_name}}</span>
                                    <span v-else>No name</span>
                                    <!-- <i class="material-icons ml-2 cursor-pointer gradient gradient-primary no-shadow text-white user-select-none edit-item-icon">create</i> -->
                                    <!-- <img src="../../assets/images/edit-icon.png" class="ml-2 edit-item-icon" @click.stop="openEditStaff" /> -->
                                    <img src="../../assets/images/edit-icon.png" class="ml-2 cursor-pointer edit-item-icon" @click.stop="openCheckPassword(item)"
                                        v-if="orderDetail.pos_status == 'payment_success'
                                          || orderDetail.pos_status == 'transaction_settled'
                                          || orderDetail.pos_status == 'refunded'" />
                                </div>
                                <!-- <div class="flex justify-between pt-1" v-for="(service, i) in item.items" :key="i">
                                    <p>{{service.quantity}} x {{service.item_name}}</p>
                                    <p>${{parseFloat(service.price).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</p>
                                </div> -->
                                <div v-for="(custom_item, i) in formatServiceList(item.items)" :key="i">
                                  <div class="mt-1" v-if="custom_item.combo_name != null">{{ custom_item.combo_name }}: </div>
                                  <div v-for="(service, j) in custom_item.items" :key="j">
                                    <div class="flex justify-between pt-1" :class="{'ml-5': custom_item.combo_name != null}">
                                      <p>{{service.quantity}} x {{service.item_name}}</p>
                                      <p>${{parseFloat(service.price).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</p>
                                    </div>
                                  </div>
                                </div>
                            </div>
                            <div>
                                <div class="flex justify-between text-primary-light pt-2 font-bold">
                                    <p>Sub Total</p>
                                    <p>${{subTotal(item)}}</p>
                                </div>
                                <div class="flex justify-between text-primary-light font-bold">
                                    <div class="flex align-center">
                                        Tip
                                        <!-- <img src="../../assets/images/edit-icon.png" class="ml-2 edit-item-icon" @click="popupTipActive = true"/> -->
                                        <!-- <i class="material-icons ml-1 cursor-pointer gradient gradient-primary no-shadow text-white user-select-none edit-item-icon">create</i> -->
                                    </div>
                                    <p>${{getTip(item.staff_id, orderDetail.tip)}}</p>
                                </div>
                            </div>
                        </div>

                        <vs-popup class="holamundo edit-group edit-popup" title="Tip for staff" :active.sync="popupTipActive">
                            <div>
                                <vs-input label="Tip" v-model="tip" class="w-full" />
                                <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                                    <vs-button class="mr-6 align-center save-responsive" @click.stop="popupTipActive = false">Save</vs-button>
                                    <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="popupTipActive = false">Cancel</vs-button>
                                </div>
                            </div>
                        </vs-popup>
                    </div>
                </div>

                <div class="subtotal-group text-custom-font">
                    <div class="flex justify-between color-black font-bold pt-1_5">
                        <p>Sub-total:</p>
                        <p v-if="this.orderDetail.total_before_discount != null">${{parseFloat(this.orderDetail.total_before_discount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</p>
                        <p v-else>$0</p>
                    </div>

                    <div class="flex justify-between color-black font-bold pt-1_5">
                        <p>Gift card price:</p>
                        <p v-if="this.orderDetail.gift_card_price != null">${{parseFloat(this.orderDetail.gift_card_price).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</p>
                        <p v-else>$0</p>
                    </div>

                    <div class="flex justify-between color-black font-bold pt-1_5">
                        <p>Promotion:</p>
                        <p>${{promotion}}</p>
                    </div>

                    <div class="flex justify-between color-black font-bold pt-1_5">
                        <p>Redeem:</p>
                        <p>${{redeem}}</p>
                    </div>

                    <div class="flex justify-between color-black font-bold pt-1_5">
                        <p>Cash discount:</p>
                        <p>${{this.orderDetail.total_cash_discount}}</p>
                    </div>

                    <div class="flex justify-between color-black font-bold pt-1_5" v-if="this.orderDetail.service_fee">
                        <p>Service fee:</p>
                        <p v-if="this.orderDetail.service_fee">${{ +(Math.round(this.orderDetail.service_fee + "e+2") + "e-2") }}</p>
                        <p v-else>$0</p>
                    </div>

                    <div class="flex justify-between color-black font-bold pt-1_5">
                        <p>TAX:</p>
                        <p v-if="this.orderDetail.tax != null">${{this.orderDetail.tax}}</p>
                        <p v-else>$0</p>
                    </div>

                    <div class="flex justify-between color-black font-bold pt-1_5">
                        <p>Tip:</p>
                        <p v-if="this.orderDetail.tip != null">${{this.orderDetail.tip.total_tip}}</p>
                        <p v-else>$0</p>
                    </div>

                    <div class="flex justify-between color-black font-bold pt-1_5" v-if="this.orderDetail.amount_info && this.orderDetail.amount_info.amount_due > 0">
                        <p>Approve amount:</p>
                        <p v-if="this.orderDetail.amount_info.approve_amount">${{ parseFloat(this.orderDetail.amount_info.approve_amount / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}</p>
                        <p v-else>$0</p>
                    </div>

                    <div class="flex justify-between color-black font-bold pt-1_5" v-if="this.orderDetail.amount_info && this.orderDetail.amount_info.amount_due > 0">
                        <p>Amount due:</p>
                        <p v-if="this.orderDetail.amount_info.amount_due">${{ parseFloat(this.orderDetail.amount_info.amount_due / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}</p>
                        <p v-else>$0</p>
                    </div>

                    <div class="flex justify-between color-black font-bold pt-1_5">
                        <p>Change:</p>
                        <p v-if="this.orderDetail.total_change != null">${{this.orderDetail.total_change}}</p>
                        <p v-else>$0</p>
                    </div>

                    <div class="flex justify-between color-black font-bold pt-1_5" v-if="this.orderDetail.pos_status == 'refunded'">
                        <p>Refund Amount:</p>
                        <p v-if="this.orderDetail.refund_amount != null">-${{this.orderDetail.refund_amount / 100}}</p>
                        <p v-else>-$0</p>
                    </div>
                </div>

                <div class="flex justify-between text-primary-light font-bold total-group text-custom-font">
                    <p>TOTAL</p>
                    <!-- <p v-if="this.orderDetail.total_after_discount != null">${{parseFloat(this.orderDetail.total_after_discount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</p>
                    <p v-else>$0</p> -->
                    <p>${{parseFloat(getTotal(this.orderDetail.total_after_discount, this.orderDetail.tip)).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</p>
                </div>
            </vx-card>
        </div>

        <vs-prompt @cancel="cancelAlert" @accept="acceptAlert" :active.sync="activePassword" type="confirm" title="Password">
            <div class="con-exemple-prompt">
                Enter the password
                <vs-input placeholder="Password" v-model="password" type="password" class="passcode-input w-full" @keyup.enter="acceptAlert" />
            </div>
        </vs-prompt>

        <checkout-staff-popup :popupStaff="popupStaff" @SelectStaff="updateStaff"></checkout-staff-popup>
    </div>
  </vs-popup>
  <custom-loading :customLoadingConfig="customLoadingConfig" :key="custom_loading_key + 'custom-loading'"></custom-loading>
</div>
</template>

<script>
import moment from 'moment';
import * as md5 from "md5";
import { StringHelper } from "../../models/string_helper";
import {changeFormatWithDateTime} from '../../helper/datetimeHelper';
export default {
  name: 'vs-popup-order-detail',
  props:{
    popupOrderDetail: {
      type: Object,
    },
    active_id: {
      type: Number
    }
  },
  data() {
        let credit_card = null
        let cash = null
        let gift_card = null
        let check = null
        let ach = null
        let external_credit_card = null
        let promotion = 0
        let redeem = 0
        let active = 0;
        active = this.active_id;
        if(active != 0){
          this.openLoadingInDiv();
          this.$store.dispatch("goPos/GET_ORDER_DETAIL", {id: active,}).then(() => {
            let data = this.$store.state.goPos.orderDetail;
            if(data && data.payment){
              for(let i=0;i<data.payment.length;i++){
                if(data.payment[i].payment_method_type == 1){
                  credit_card = data.payment[i].total_paid;
                }
                if(data.payment[i].payment_method_type == 2){
                  cash = data.payment[i].total_paid;
                }
                if(data.payment[i].payment_method_type == 3){
                  gift_card = data.payment[i].total_paid;
                }
                if(data.payment[i].payment_method_type == 4){
                  check = data.payment[i].total_paid;
                }
                if(data.payment[i].payment_method_type == 5){
                  ach = data.payment[i].total_paid;
                }
              }
            }
            if(data.external_credit_card == 1) {
              external_credit_card = credit_card || data.order_batch.external_cc_amount;
              // credit_card = 0;
            }
            if(data && data.order_discount && data.order_discount.length > 0){
              for(let i = 0; i<data.order_discount.length;i++){
                if(data.order_discount[i].item_type == 'customer_campaign'){
                  promotion = data.order_discount[i].total_discount
                }
                if(data.order_discount[i].item_type == 'reward'){
                  redeem = data.order_discount[i].total_discount
                }
              }
            }
            this.$store.dispatch("goPos/GET_LIST_ORDER_HISTORY", {order_id: this.active_id}).then(() => {
              this.getShowYear();
              this.closeLoading();
            })
          })
        }
        let note_temp = '';
        if(this.orderDetail){
          note_temp = this.orderDetail.note;
        }
        return {
            active,
            note_temp,
            note_view: '',
            StringHelper,
            checkinShowYear: [],
            sub_total: 135,
            promotion,
            redeem,
            credit_card,
            cash,
            gift_card,
            check,
            ach,
            external_credit_card,
            tax: 13.5,
            total: 148.5,
            popupNote: false,
            isOpenLoading : false,
            tip: 0,
            popupTipActive: false,
            popupStaff: {
                isOpen: false,
                item_info: {
                    service: { name: 'Order Item' },
                    staff: null,
                },
                itemList: []
            },
            activeOrderItem: null,
            right_content_key: 0,
            activePassword: false,
            password: '',
            action_type: 'Get list',
            customLoadingConfig: {
                isOpen: false
            },
            custom_loading_key: 0,
            // is_pax: false
        }
    },
    methods: {
      openLoadingInDiv(){
          this.$vs.loading({
            container: '#app',
            scale: 0.8
          })
          if(this.loadTime){
              clearTimeout(this.loadTime);
              this.loadTime = null;
          }
          this.isOpenLoading = true;
          this.loadTime = setTimeout( ()=> {
              if(this.isOpenLoading) {
                  this.closeLoading();
                  this.$vs.dialog({
                      color: 'danger',
                      title: 'Notification',
                      text: this.action_type + ' Failed',
                      acceptText: 'OK'
                  })
              }
          }, 5000);
        },
        closeLoading() {
          this.$vs.loading.close('#app > .con-vs-loading');
          this.isOpenLoading = false;
        },
        getTip(staff_id, tip) {
            if(tip && tip.data && tip.data.length > 0) {
                for(let i = 0; i < tip.data.length; i++) {
                    if(tip.data[i].staff_id == staff_id && tip.data[i].value != null) {
                        return tip.data[i].value;
                    }
                }
            }
            return 0;
        },
      formatServiceList(list) {
        let result = [];
        if(list && list.length > 0) {
          for(let i = 0; i < list.length; i++) {
            let items = [];
            let existed_combo_index = -1;
            if(list[i].combo_name && result.length > 0) {
              for(let j = 0; j < result.length; j++) {
                if(result[j].combo_name && result[j].combo_name == list[i].combo_name) {
                  existed_combo_index = j;
                  j = result.length;
                }
              }
            }
            if(existed_combo_index != -1 && result[existed_combo_index] && result[existed_combo_index].combo_name) {
              result[existed_combo_index].items.push(list[i]);
            } else {
              items.push(list[i]);
              result.push({
                combo_name: list[i].combo_name,
                items
              })
            }
          }
        }
        return result;
      },
      goToOrder(item){
        if(item.id != this.active){
          if(item.id != 0){
            this.active = item.id;
            this.openLoadingInDiv();
            this.action_type = "Get Data";
            this.$store.dispatch("goPos/GET_ORDER_DETAIL", {id: item.id,}).then(() => {
              this.closeLoading();
              let data = this.$store.state.goPos.orderDetail;
              this.credit_card = 0;
              this.cash = 0;
              this.gift_card = 0;
              this.check = 0;
              this.ach = 0;
              this.external_credit_card = 0;
              if(data && data.payment){
                for(let i=0;i<data.payment.length;i++){
                  if(data.payment[i].payment_method_type == 1){
                    this.credit_card = data.payment[i].total_paid;
                  }
                  if(data.payment[i].payment_method_type == 2){
                    this.cash = data.payment[i].total_paid;
                  }
                  if(data.payment[i].payment_method_type == 3){
                    this.gift_card = data.payment[i].total_paid;
                  }
                  if(data.payment[i].payment_method_type == 4){
                    this.check = data.payment[i].total_paid;
                  }
                  if(data.payment[i].payment_method_type == 5){
                    this.ach = data.payment[i].total_paid;
                  }
                }
              }
              if(data.external_credit_card == 1) {
                this.external_credit_card = this.credit_card || data.order_batch.external_cc_amount;
                // this.credit_card = 0;
              }
              this.promotion = 0;
              this.redeem = 0;
              if(data && data.order_discount && data.order_discount.length > 0){
                for(let i = 0; i<data.order_discount.length;i++){
                  if(data.order_discount[i].item_type == 'customer_campaign'){
                    this.promotion = data.order_discount[i].total_discount
                  }
                  if(data.order_discount[i].item_type == 'reward'){
                    this.redeem = data.order_discount[i].total_discount
                  }
                }
              }
              this.right_content_key++;
            })
            this.$store.dispatch("goPos/GET_LIST_ORDER_HISTORY", {order_id: item.id}).then(() => {
              this.closeLoading();
              this.getShowYear();
            })
          }
        }
      },
      closePopup(){
        this.$emit("ClosePopup")
      },
      getStatusColor(status) {
            if(status == 'processing') {
                return '#FF9F43';
            } else if (status == 'pending') {
                return '#438D00';
            } else if (status == 'cancelled') {
                return '#E20E0E';
            } else if (status == 'refunded') {
                return '#FBBA17'
            } else if (status == 'voided') {
                return '#ED6EF2'
            } else if (status == 'payment_success') {
                return '#5B94E2'
            } else if (status == 'transaction_settled') {
                return '#844CEF'
            } else if (status == 'settlement_failed') {
                return '#E20E0E'
            } else if (status == 'awaiting_payment') {
                return '#438D00'
            }
        },
        getNameStatus(status) {
          if(status == 'cancelled'){
              return 'Cancelled'
          } else if(status == 'pending'){
              return 'Pending'
          } else if(status == 'processing'){
              return 'Processing'
          } else if (status == 'refunded') {
              return 'Refunded'
          } else if (status == 'voided') {
              return 'Voided'
          } else if (status == 'payment_success') {
              return 'Payment Success'
          } else if (status == 'transaction_settled') {
              return 'Settled'
          } else if (status == 'settlement_failed') {
              return 'Settlement Failed'
          } else if (status == 'awaiting_payment') {
              return 'Awaiting Payment'
          }
        },
      openEditStaff() {
          this.popupStaff.isOpen = true;
      },
      changeFormat(day){
        if(day) {
          return changeFormatWithDateTime(day);
        } else {
          return 'N/A';
        }
      },
      subTotal(item){
        let total = 0;
        for(let i = 0; i < item.items.length; i++){
          total = total + item.items[i].price;
        }
        return parseFloat(total).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      },
      formatTwoFixedAmount(amount) {
        if(amount) {
          return parseFloat(amount / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        }
        return '0.00';
      },
      getDayOfWeek(date) {
          return moment(date).format("ddd");
      },
      getDayOfMonth(date) {
          return moment(date).format("DD");
      },
      getYear(date) {
          return moment(date).format("YYYY");
      },
      getMonth(date) {
          return moment(date).format("MMM");
      },
      getShowYear() {
          this.showYear = [];
          let curYear = 0;
          let prev_year = curYear;
          let arr_checkin = this.$store.state.goPos.historyOrderList.items;

          for (let i = 0; i < arr_checkin.length; i++) {
              let year = this.getYear(arr_checkin[i].created_at);
              if (year == curYear) {
                  this.checkinShowYear.push(false);
              } else if (year != prev_year) {
                  prev_year = year;
                  this.checkinShowYear.push(true);
              } else {
                  this.checkinShowYear.push(false);
              }
          }
      },
      updateNote() {
          if(this.orderDetail) {
              const obj = {
                  phone: this.orderDetail.customer_phone,
                  note: this.note,
                  page: this.currentPage,
                  "per-page": this.itemsPerPage,
                  id: this.orderDetail.id
              }
              if(!this.isOpenLoading) {
                  this.openLoadingInDiv();
              }
              this.action_type = "Update Customer Note";
              this.$store.dispatch('checkin/UPDATE_CUSTOMER_NOTE', obj).then(() => {
                this.closeLoading();
                  this.$vs.notify({
                  title:'Notification',
                  text:'Update Customer Note Successful',
                  color:'success',
                  position:'top-right'});
                  this.popupNote = false;
                  this.note_view = this.note_temp;
              }).catch(() => {
                  this.closeLoading();
                  this.$vs.notify({
                  title:'Notification',
                  text:'Update Customer Note Failed',
                  color:'danger',
                  position:'top-right'});
                  this.popupNote = false;
              })

          }
      },
      openCheckPassword(item) {
          this.popupStaff.item_info.staff = { user_id: item.staff_id };
          this.activeOrderItem = item;
          this.popupStaff.itemList = item.items;
          this.activePassword = true;
      },
      acceptAlert() {
          if (this.password == "123456abcA"){
              this.popupStaff.isOpen = true;
              this.password = '';
              this.activePassword = false;
            return;
          }
      if (this.config.passcode !== undefined) {
        console.log(this.config.passcode);
        if (md5(this.password + "GCI2020") == this.config.passcode) {
          this.activePassword = false;
          this.popupStaff.isOpen = true;
          this.password = "";
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Authentication succesfully!",
          });
        }
        else {
          this.activePassword = true;
          this.$vs.notify({
            color: "danger",
            title: "Failed",
            text: "Authentication failed!",
          });
        }
      } else {
        this.activePassword = false;
        this.popupStaff.isOpen = true;
        this.password = "";
        this.$vs.notify({
          color: "success",
          title: "Success",
          text: "Authentication succesfully!",
        });
      }
      },
      cancelAlert() {
          this.activePassword = false;
          this.password = "";
      },
      updateStaff(selected_data) {
          let data = {
              order_id: this.activeOrderItem.order_id,
              // order_item_id: this.activeOrderItem.id,
              order_item_id: selected_data.items,
              staff_id: selected_data.staff.user_id
          }
          if(!this.isOpenLoading) {
              this.openLoadingInDiv();
          }
          this.action_type = "Update Staff";
          this.$store.dispatch('goPos/UPDATE_ORDER_STAFF', data).then(() => {
              this.closeLoading();
              this.customLoadingConfig.isOpen = true;
              this.custom_loading_key++;
              setTimeout(() => {
                  this.customLoadingConfig.isOpen = false;
                  this.popupStaff.isOpen = false;
                  this.$vs.notify({
                      title:'Notification',
                      text:'Update Staff Successful',
                      color:'success',
                      position:'top-right'});
              }, 5000);
          }).catch((err) => {
              console.log('Error: ' + err);
              this.closeLoading();
              this.$vs.notify({
                  title:'Notification',
                  text:'Update Staff Failed',
                  color:'danger',
                  position:'top-right'});
          })
      },
      getTotal(total, tip) {
        let temp_total = total ? total : 0;
        let temp_tip = tip ? tip.total_tip : 0;
        return parseFloat(temp_total) + parseFloat(temp_tip);
      }
    },
    watch:{
      popupNote: {
          immediate: true,
          deep: true,
          handler() {
            if(this.popupNote) {
              this.note_temp = this.note_view;
            }
          }
      },
      orderDetail: {
        immediate: true,
        deep: true,
        handler() {
          if(this.orderDetail){
            this.note_temp = this.orderDetail.note;
            this.note_view = this.note_temp;
            this.credit_card = 0;
            this.cash = 0;
            this.gift_card = 0;
            this.check = 0;
            this.ach = 0;
            this.external_credit_card = 0;
            if(this.orderDetail.payment && this.orderDetail.payment.length > 0){
              for(let i=0;i<this.orderDetail.payment.length;i++){
                if(this.orderDetail.payment[i].payment_method_type == 1){
                  this.credit_card = this.orderDetail.payment[i].total_paid;
                }
                if(this.orderDetail.payment[i].payment_method_type == 2){
                  this.cash = this.orderDetail.payment[i].total_paid;
                }
                if(this.orderDetail.payment[i].payment_method_type == 3){
                  this.gift_card = this.orderDetail.payment[i].total_paid;
                }
                if(this.orderDetail.payment[i].payment_method_type == 4){
                  this.check = this.orderDetail.payment[i].total_paid;
                }
                if(this.orderDetail.payment[i].payment_method_type == 5){
                  this.ach = this.orderDetail.payment[i].total_paid;
                }
              }
            }
            if(this.orderDetail.external_credit_card == 1) {
              this.external_credit_card = this.credit_card || this.orderDetail.order_batch.external_cc_amount;
              // this.credit_card = 0;
            }
            this.promotion = 0;
            this.redeem = 0;
            if(this.orderDetail && this.orderDetail.order_discount && this.orderDetail.order_discount.length > 0){
              for(let i = 0; i<this.orderDetail.order_discount.length;i++){
                if(this.orderDetail.order_discount[i].item_type == 'customer_campaign'){
                  this.promotion = this.orderDetail.order_discount[i].total_discount
                }
                if(this.orderDetail.order_discount[i].item_type == 'reward'){
                  this.redeem = this.orderDetail.order_discount[i].total_discount
                }
              }
            }
            this.right_content_key++;
          }
        }
      },
    },
    computed: {
      paymentHistory() {
        let data = this.$store.state.goPos.orderDetail;
        // console.log(data);
        let result = {
          payment: null,
          tip: 0,
          refund: null,
          void: null,
          is_pax: false
        };
        let tip = 0;
        // this.is_pax = false;
        if(data && data.payment_history && data.payment_history.length > 0) {
          for(let i = 0; i < data.payment_history.length; i++) {
            let payment_type = data.payment_history[i].type;
            if(data.payment_history[i].data) {
              let payment_info = JSON.parse(data.payment_history[i].data);
              if(payment_type == 'CLOVER_SALE_RESPONSE' || payment_type == 'CLOVER_AUTH_RESPONSE') {
                let item = {
                  created_date: moment(payment_info.createdTime).format('MMM, DD, YYYY'),
                  created_time: moment(payment_info.createdTime).format('HH:mm A'),
                  amount: this.formatTwoFixedAmount(payment_info.amount),
                  // success: payment_info.result == 'SUCCESS' ? true : false,
                  tender: payment_info.tender ? payment_info.tender.label : 'N/A',
                  paymentId: payment_info.id,
                  orderId: payment_info.order ? payment_info.order.id : 'N/A',
                  // cardType: payment_info.cardTransaction ? payment_info.cardTransaction.cardType : 'N/A',
                  // last4: payment_info.cardTransaction ? payment_info.cardTransaction.last4 : '',
                  // transactionNo: payment_info.cardTransaction ? payment_info.cardTransaction.transactionNo : 'N/A'
                }

                result.payment = item;

                if(payment_info.tipAmount) {
                  tip = payment_info.tipAmount;
                }
              }

              if(payment_type == 'CLOVER_VOID_RESPONSE') {
                let item = {
                  created_date: moment(payment_info.payment.createdTime).format('MMM, DD, YYYY'),
                  created_time: moment(payment_info.payment.createdTime).format('HH:mm A'),
                  amount: this.formatTwoFixedAmount(payment_info.payment.amount + (payment_info.payment.tipAmount ? payment_info.payment.tipAmount : 0)),
                  // success: payment_info.result == 'SUCCESS' ? true : false,
                  tender: payment_info.payment.tender ? payment_info.payment.tender.label : 'N/A',
                  paymentId: payment_info.paymentId,
                  orderId: payment_info.payment && payment_info.payment.order ? payment_info.payment.order.id : 'N/A',
                  // cardType: payment_info.payment.cardTransaction ? payment_info.payment.cardTransaction.cardType : 'N/A',
                  // last4: payment_info.payment.cardTransaction ? payment_info.payment.cardTransaction.last4 : '',
                  // transactionNo: payment_info.payment.cardTransaction ? payment_info.payment.cardTransaction.transactionNo : 'N/A'
                }

                result.void = item;
              }

              if(payment_type == 'CLOVER_RETURN_RESPONSE') {
                let item = {
                  created_date: moment(payment_info.refund.createdTime).format('MMM, DD, YYYY'),
                  created_time: moment(payment_info.refund.createdTime).format('HH:mm A'),
                  amount: this.formatTwoFixedAmount(payment_info.refund.amount),
                  // success: payment_info.result == 'SUCCESS' ? true : false,
                  paymentId: payment_info.paymentId,
                  orderId: payment_info.orderId
                }

                result.refund = item;
              }

              if(payment_type == 'CLOVER_ADJUST_RESPONSE') {
                tip = payment_info.tipAmount;
              }

              if(payment_type == 'ADJUST_RESPONSE' || payment_type == 'VOID_RESPONSE' || payment_type == 'SALE_RESPONSE' || payment_type == 'RETURN_RESPONSE') {
                // this.is_pax = true;
                result.is_pax = true;
                if(payment_info.extra_data && payment_info.extra_data.amountInformationRaw) {
                  let amount_info = payment_info.extra_data.amountInformationRaw.split('\u001f');
                  if(amount_info && amount_info[2] && amount_info[2] > 0) {
                    tip = amount_info[2];
                  }
                }

                let item = {
                  created_date: data.payment_history[i].created_at ? moment(data.payment_history[i].created_at).format('MMM, DD, YYYY') : 'N/A',
                  created_time: data.payment_history[i].created_at ? moment(data.payment_history[i].created_at).format('HH:mm A') : '',
                  amount: this.formatTwoFixedAmount(payment_info.amount),
                  // success: true,
                  cardType: data.card_type,
                  last4: data.last_four,
                  transactionNo: payment_info.extra_data && payment_info.extra_data.traceInformation ? payment_info.extra_data.traceInformation.transaction_number : 'N/A',
                }

                if(payment_type == 'ADJUST_RESPONSE' || payment_type == 'SALE_RESPONSE') {
                  if(tip > 0) {
                    item.amount = this.formatTwoFixedAmount(payment_info.amount - tip);
                  }
                  result.payment = item;
                }

                if(payment_type == 'VOID_RESPONSE') {
                  result.void = item;
                }

                if(payment_type == 'RETURN_RESPONSE') {
                  result.refund = item;
                }
              }
            }
          }
        }

        result.tip = tip ? this.formatTwoFixedAmount(tip) : 0;
        // console.log(result);
        return result;
      },
      orderDetail(){
        return this.$store.state.goPos.orderDetail;
      },
      historyOrderList(){
        return this.$store.state.goPos.historyOrderList;
      },
      note: {
        get() {
          return this.note_temp;
        },
        set(value) {
          this.note_temp = value;
        }
      },
      config() {
            return this.$store.getters["auth/config"];
      },
    },
}
</script>
